import styled from 'styled-components'

export const Container = styled.div`

  display: flex;

  flex-direction: column;
  padding: 10px 30px 30px 30px;
  gap:20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding: 10px 16px 30px;
    box-sizing: border-box;
  }
`

export const DarkForm = styled.div`
  display: flex;
  background-color: ${({theme}) => theme.palette[200]};
  align-items: flex-start;
  border-radius: 8px;
  margin-top: 10px;
  width:100%;
  box-sizing: border-box;
  padding: 14px;
  flex-grow: 2;
  gap:10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;

    & > div {
      width: 100%;
      min-width: 0;
      max-width: 100%;
    }
  }
`
type HideProps = {
  active:boolean,
}
export const HideContainer = styled.div<HideProps>`
  max-height: ${({active}) => active ? '1000px' : '0px'};
  overflow:${({active}) => active ? '' : 'hidden'};
  transition: max-height 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap:20px;
`
